import CONFIG from '../../globals/config'
import {
  RestaurantCategoryTemplate,
  RestaurantDrinkTemplate,
  RestaurantFoodTemplate,
  RestaurantReviewTemplate
} from './template-creator'

const RestaurantDetailTemplate = (restaurant) => {
  const { categories, menus, customerReviews } = restaurant
  const { foods, drinks } = menus

  let Category = ''
  categories.map((category) => {
    Category += RestaurantCategoryTemplate(category)
    return Category
  })

  let Food = ''
  foods.map((food) => {
    Food += RestaurantFoodTemplate(food)
    return Food
  })

  let Drink = ''
  drinks.map((drink) => {
    Drink += RestaurantDrinkTemplate(drink)
    return Drink
  })

  let reviews = ''
  customerReviews.map((customerReview) => {
    reviews += RestaurantReviewTemplate(customerReview)
    return reviews
  })

  return `
    <div class="detail">
      <div class="detail__image">
        <picture>
          <source media="(max-width: 780px)" srcset="${CONFIG.BASE_IMAGE_MEDIUM_URL + restaurant.pictureId}">
          <img 
            class="lazyload" 
            data-src="${CONFIG.BASE_IMAGE_LARGE_URL + restaurant.pictureId}"
            alt="${restaurant.name}"
          />
        </picture>
        <div id="favorite" class="detail__favorite"></div>
      </div>

      <div class="detail-info">
        <div class="detail-info__categories">${Category}</div>
        <div class="detail-info__name">${restaurant.name}</div>
        <div class="detail-info__city-address">
          <div class="city"><i class="fa fa-map" aria-hidden="true"></i> ${restaurant.city}</div>
          <div class="point">.</div>
          <div class="address">${restaurant.address}</div>
        </div>
        <div class="detail-info__rating-review">
          <div class="rating"><i class="fa fa-star" aria-hidden="true"></i> ${restaurant.rating}</div>
          <div class="review review-count">(${restaurant.customerReviews.length} Review)</div>
        </div>
        <div class="detail-info__write-review show"><i class="fa fa-comment" aria-hidden="true"></i> Write Review</div>
        <div class="accordion">Foods <i class="fa fa-chevron-right" aria-hidden="true"></i></div>
        <div class="panel">
          <div class="food-container">
            ${Food}
          </div>
        </div>
        <div class="accordion">Drinks <i class="fa fa-chevron-right" aria-hidden="true"></i></div>
        <div class="panel">
          <div class="food-container">
            ${Drink}
          </div>
        </div>
        <div class="accordion">Description <i class="fa fa-chevron-right" aria-hidden="true"></i></div>
        <div class="panel">
          <p>${restaurant.description}</p>
        </div>
        <div class="accordion">Reviews <i class="fa fa-chevron-right" aria-hidden="true"></i></div>
        <div class="panel">
          <div class="review-container">
            ${reviews}
          </div>
        </div>
      </div>
    </div>
    <app-modal data="123"></app-modal>
  `
}

export default RestaurantDetailTemplate
